import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ThematicPortfoliosRoutingModule } from './thematic-portfolios-routing.module';
import { ThematicPortfoliosComponent } from 'src/app/pages/thematic-portfolios/thematic-portfolios.component';
import { StaticPageFooterModule } from 'src/app/shared/static-page-footer/static-page-footer.module';
import { HtmlFormatPipeModule } from 'src/app/pipes/html-format-pipe.module';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    ThematicPortfoliosComponent,
  ],
  imports: [
    CommonModule,
    ThematicPortfoliosRoutingModule,
    StaticPageFooterModule,
    HtmlFormatPipeModule,
    TranslateModule,
    RouterModule,
  ],
  exports: [
    ThematicPortfoliosComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class ThematicPortfoliosModule { }
